var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row "},[_c('div',{staticClass:"col-lg-12 wrap-errors"},[(_vm.serverErrors)?_c('ul',{staticClass:"ul-errors"},_vm._l((_vm.serverErrors),function(value,key){return _c('li',{key:key},[_vm._v(_vm._s(key)+".  "+_vm._s(value[0]))])}),0):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e03fb0b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app_modules/Errors.vue
// module id = 176
// module chunks = 0